import * as ini from 'ini';

type IniConfig = Record<string, any>;

function preprocessIniContent(iniContent: string | object): string {
  if (typeof iniContent !== 'string') {
    return ini.stringify(iniContent);
  }
  return iniContent
    .split('\n')
    .map((line) => {
      const separatorIndex = line.indexOf('=');
      if (separatorIndex !== -1 && line.includes('|')) {
        const key = line.substring(0, separatorIndex).trim();
        const value = line.substring(separatorIndex + 1).trim();
        return `${key}="${value}"`;
      }
      return line;
    })
    .join('\n');
}

export function iniToJson(iniContent: string): IniConfig {
  try {
    const preprocessedContent = preprocessIniContent(iniContent);
    const config: IniConfig = ini.parse(preprocessedContent);
    return config;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}
